import { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styleShape from 'react-style-proptype'
import { themr } from '../react-css-themr'
import { CHECKBOX } from '../identifiers'
import rippleFactory from '../ripple/Ripple'
import checkFactory from './Check'

const factory = Check => {
  class Checkbox extends Component {
    static propTypes = {
      checked: PropTypes.bool,
      children: PropTypes.node,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      name: PropTypes.string,
      onChange: PropTypes.func,
      onMouseEnter: PropTypes.func,
      onMouseLeave: PropTypes.func,
      style: styleShape,
      theme: PropTypes.shape({
        disabled: PropTypes.string,
        field: PropTypes.string,
        input: PropTypes.string,
        ripple: PropTypes.string,
      }),
    }

    handleToggle = event => {
      const { checked = false, disabled = false, onChange } = this.props
      if (event.pageX !== 0 && event.pageY !== 0) this.blur()
      if (!disabled && onChange) {
        onChange(!checked, event)
      }
    }

    blur() {
      if (this.inputNode) {
        this.inputNode.blur()
      }
    }

    focus() {
      if (this.inputNode) {
        this.inputNode.focus()
      }
    }

    render() {
      const {
        checked = false,
        children,
        className = '',
        disabled = false,
        label,
        name,
        style,
        onChange,
        onMouseEnter,
        onMouseLeave,
        theme,
        ...others
      } = this.props
      const combinedClassName = cx(
        theme.field,
        {
          [theme.disabled]: disabled,
        },
        className
      )

      return (
        <label
          data-react-toolbox='checkbox'
          className={combinedClassName}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <input
            {...others}
            checked={checked}
            className={theme.input}
            disabled={disabled}
            name={name}
            onChange={() => {}}
            onClick={this.handleToggle}
            ref={node => {
              this.inputNode = node
            }}
            type='checkbox'
          />
          <Check
            checked={checked}
            disabled={disabled}
            rippleClassName={theme.ripple}
            style={style}
            theme={theme}
          />
          {label ? (
            <span data-react-toolbox='label' className={theme.text}>
              {label}
            </span>
          ) : null}
          {children}
        </label>
      )
    }
  }

  return Checkbox
}

const Check = checkFactory(rippleFactory({ centered: true, spread: 2.6 }))
const Checkbox = factory(Check)
export default themr(CHECKBOX)(Checkbox)
export { factory as checkboxFactory }
export { Checkbox }
